import email from "../assets/email.webp";
import solidity from "../assets/solidity.webp";
import python from "../assets/python.webp";
import react from "../assets/react.webp";
import profile from "../assets/profile.webp";
import circle from "../assets/circle.svg";
import logo from "../assets/logo.webp";
import next from "../assets/next-js.svg";

const images = {
  email,
  solidity,
  python,
  react,
  profile,
  circle,
  logo,
  next,
};

export default images;
